<template>
    <console-content>
        <v-row class="mt-3" align="center">
            <v-col cols="auto" class="py-0">
                <span class="headline">핀 번호 관리</span>
            </v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mx-auto">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-responsive>
                        <v-row class="pl-3">권종</v-row>
                        <v-row>
                            <v-col class="py-0">
                                <v-checkbox label="전체" :input-value="!filter.lv.length" @click="filter.lv = []" dense
                                    hide-details class="mt-0"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row v-for="(row, i) in Math.ceil(levels.length / 5)" :key="i">
                            <v-col v-for="(col, j) in 5" :key="j" class="py-0">
                                <v-checkbox v-if="levels[i*5 + j]" v-model="filter.lv" :label="levels[i*5 + j].name" :value="levels[i*5 + j].code" dense hide-details class="mt-0"></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-responsive>

                    <v-row class="mt-6">
                        <v-col cols="12" sm="12" md="3" class="py-0">
                            <v-select v-model="filter.status" multiple label="핀 상태" placeholder=" " :items="statusItems" item-text="name" item-value="value" ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" class="py-0">
                            <v-select v-model="filter.locked" label="핀 잠금상태" placeholder=" " :items="lockedItems" item-text="name" item-value="value" hide-details></v-select>
                        </v-col>
                    </v-row>

                    <v-row class="mt-3">
                        <v-col cols="12" md="3" class="py-0">
                            <v-select v-model="filter.dateType" label="검색일자" placeholder=" " :items="dateItems"
                                item-text="name" item-value="value"></v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="py-0">
                            <v-date-field v-model="filter.date[0]" label="시작일" placeholder=" " clearable :disabled="!filter.dateType"></v-date-field>
                        </v-col>
                        <v-col cols="12" md="3" class="py-0">
                            <v-date-field v-model="filter.date[1]" label="종료일" placeholder=" " clearable :disabled="!filter.dateType"></v-date-field>
                        </v-col>
                    </v-row>

                    <v-row class="mt-3">
                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field v-model="filter.gno[0]" label="발권번호" placeholder="발권시작번호" clearable>
                                    </v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field v-model="filter.gno[1]" label="발권번호" placeholder="발권종료번호" clearable>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-row>
                                <v-col cols="12" sm="12" md="6" class="py-0">
                                    <v-text-field v-model="filter.pno" label="핀번호" placeholder=" " clearable>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" class="py-0">
                                    <v-text-field v-model="filter.phone" label="수신자번호" placeholder=" " clearable>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="12" sm="12" md="3" class="py-0">
                            <v-row>
                                <v-col class="py-0">
                                    <v-select v-model="filter._cp" :items="cps" item-text="name" item-value="_id" label="발행처" placeholder=" " hide-details></v-select>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" class="py-0">
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field v-model="filter.place" label="사용처" placeholder=" " hide-details />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider />

                <excel-pins v-model="filter.pnos" class="mt-4" />

                <v-divider />

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search()">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-4">
            <v-col cols="3" class="pr-1">
                <v-card :loading="loadingDashboard" class="elevation-1">
                    <v-card-text v-if="!loadingDashboard">
                        <v-row>
                            <v-col cols="auto" class="py-0 caption">합계(발행 + 사용)</v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-0 text-end caption">
                                <span class='font-weight-bold'>{{( +totalIssue.count + +totalPay.count).format() }}</span> 건 <br>
                                <span class='font-weight-bold'>{{( totalIssue.price + totalPay.price).format() }}</span> 원
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-else>searching...</v-card-text>
                </v-card>
            </v-col>
            <v-col cols="3" class="px-1">
                <v-card :loading="loadingDashboard" class="elevation-1">
                    <v-card-text v-if="!loadingDashboard">
                        <v-row>
                            <v-col cols="auto" class="py-0 caption">발행(미사용)</v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-0 text-end caption">
                                <span class='font-weight-bold'>{{( totalIssue.count).format() }}</span> 건 <br>
                                <span class='font-weight-bold'>{{( totalIssue.price).format() }}</span> 원
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-else>searching...</v-card-text>
                </v-card>
            </v-col>
            <v-col cols="3" class="px-1">
                <v-card :loading="loadingDashboard" class="elevation-1">
                    <v-card-text v-if="!loadingDashboard">
                        <v-row>
                            <v-col cols="auto" class="py-0 caption">사용</v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-0 text-end caption">
                                <span class='font-weight-bold'>{{( totalPay.count).format() }}</span> 건 <br>
                                <span class='font-weight-bold'>{{( totalPay.price).format() }}</span> 원
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-else>searching...</v-card-text>
                </v-card>
            </v-col>
            <v-col cols="3" class="pl-1">
                <v-card :loading="loadingDashboard" class="elevation-1">
                    <v-card-text v-if="!loadingDashboard">
                        <v-row>
                            <v-col cols="auto" class="py-0 caption">폐기</v-col>
                            <v-spacer />
                            <v-col cols="auto" class="py-0 text-end  caption">
                                <span class='font-weight-bold'>{{( totalCancel.count).format() }}</span> 건 <br>
                                <span class='font-weight-bold'>{{( totalCancel.price).format() }}</span> 원
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-else>searching...</v-card-text>
                </v-card>
            </v-col>
        </v-row>


        <v-row v-if="!hasViewerScope" class="mt-4" align="center">
            <v-col cols="auto">선택한 핀을</v-col>
            <v-col cols="auto">
                <v-btn color="white" class="red--text pl-2 mr-1" @click="cancel(false)">
                    <v-icon class="mr-2">{{ mdiTrashCanOutline }}</v-icon>폐기
                </v-btn>
                <v-btn color="white" class="light-blue--text pl-2 mr-1" @click="unlock(false)">
                    <v-icon class="mr-2">mdi-lock-open-outline</v-icon>활성
                </v-btn>
                <v-btn color="white" class="blue--text pl-2 mr-1" @click="lock(false)">
                    <v-icon class="mr-2">mdi-lock</v-icon>비활성
                </v-btn>
                <!-- <v-btn color="white" class="indigo--text pl-2" @click="editPlatform(false)">
                    <v-icon class="mr-2">{{ mdiLayers }}</v-icon>플랫폼변경
                </v-btn> -->
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="pr-2">검색한 핀을</v-col>
            <v-col cols="auto">
                <v-btn color="white" @click="unlock(true)" class="light-blue--text pl-2 mr-1">
                    <v-icon class="mr-2">mdi-lock-open-outline</v-icon>대량활성
                </v-btn>
                <v-btn color="white" @click="lock(true)" class="blue--text pl-2 mr-1">
                    <v-icon class="mr-2">mdi-lock</v-icon>대량비활성
                </v-btn>
                <v-btn color="white" @click="cancel(true)" class="red--text pl-2 mr-1">
                    <v-icon class="mr-2">{{ mdiTrashCanOutline }}</v-icon>대량폐기
                </v-btn>
                <!-- <v-btn color="white" @click="editPlatform(true)" class="indigo--text pl-2 mr-1">
                    <v-icon class="mr-2">{{ mdiLayers }}</v-icon>플랫폼변경
                </v-btn> -->
                <v-btn color="white" @click="excel()" class="green--text pl-2">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀출력
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table v-model="selected" show-select
            :headers="pinHeaders" :items="pins"
            :loading="loadingPins" item-key="_id" disable-sort disable-pagination hide-default-footer
            class="elevation-1">
            <template v-slot:item.gno="{ item }">
                {{ item.cd + item.lv + item.no.toString().padStart(13, 0) }}
            </template>

            <template v-slot:item.faceamt="{ item }">
                {{ item.faceamt.format() }}
            </template>

            <template v-slot:item.locked="{ item }">
                <v-icon v-if="item.locked" color="primary">mdi-lock</v-icon>
                <v-icon v-else color="primary">mdi-lock-open-outline</v-icon>
            </template>

            <template v-slot:item.phone="{ item }">
                {{ item.phone.phoneNumberFormat() }}
            </template>

            <template v-slot:item.status="{ item }">
                <span v-if="item.status == 0">발권</span>
                <span v-if="item.status == 1">발행</span>
                <span v-if="item.status == 7">사용</span>
                <span v-if="item.status == 8">폐기</span>
            </template>

            <template v-slot:item.issuedAt="{ item }">
                <span v-if="item.issuedAt">{{ item.issuedAt.toDateTime() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.payedAt="{ item }">
                <span v-if="item.payedAt">{{ item.payedAt.toDateTime() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.canceledAt="{ item }">
                <span v-if="item.canceledAt">{{ item.canceledAt.toDateTime() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.expiredAt="{ item }">
                <span v-if="item.expiredAt">{{ item.expiredAt.toDateTime() }}</span>
                <span v-else>-</span>
            </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pageCount" total-visible="9" class="mt-4 mb-12" @input="search"></v-pagination>

        <platform-dialog ref="platform-dialog" @update="search"></platform-dialog>
        
    </console-content>
</template>

<script>
import api from "@/api";
import levels from "@/assets/data/levels";

import ConsoleContent from "@/components/console/console-content.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import PlatformDialog from '@/components/console/pin/platform-dialog.vue';
import ExcelPins from "@/components/console/pin/excel-pins.vue";

import XLSX from 'xlsx';
import dayjs from "dayjs";
import { mdiMicrosoftExcel, mdiTrashCanOutline, mdiLayers   } from '@mdi/js';
import { mapGetters } from "vuex";

export default {
    components: {
        ConsoleContent,
        VDateField,
        PlatformDialog,
        ExcelPins
    },
    props: {
        _category: { type: String, default: null },
        _platform: { type: String, default: null },
        type: { type: String, default: null }
    },
    data() {
        return {
            mdiLayers,
            mdiMicrosoftExcel,
            mdiTrashCanOutline,

            levels,

            showSearch: true,

            categories: [],
            cps: [],

            filter: {
                _category: this.$props._category ?? null,
                _platform: this.$props._platform ?? null,

                cd: null,
                lv: [],
                status: [],
                locked: null,
                type: this.$props.type,

                dateType: null,
                date: ["", ""],

                gno: ["", ""],
                pno: null,
                pnos: [],
                phone: null,
                publisher: null,
                place: null,
            },

            page: 1,
            pageCount: 1,
            limit: 100,

            dashboard: [],
            loadingDashboard: true,
            
            all: false,
            selected: [],

            loadingPins: true,

            pins: [],
            pinHeaders: [{
                    text: '발권번호',
                    width: 160,
                    align: 'center',
                    sortable: false,
                    value: 'gno',
                },
                {
                    text: '핀번호',
                    width: 100,
                    align: 'center',
                    value: 'pno'
                },
                {
                    text: '액면가',
                    width: 128,
                    align: 'center',
                    value: 'faceamt'
                },
                {
                    text: '핀 상태',
                    width: 100,
                    align: 'center',
                    value: 'status'
                },
                {
                    text: '활성/비활성',
                    width: 100,
                    align: 'center',
                    value: 'locked'
                },
                {
                    text: '수신자번호',
                    width: 128,
                    align: 'center',
                    value: 'phone'
                },
                {
                    text: '발행일자',
                    width: 164,
                    align: 'center',
                    value: 'issuedAt'
                },
                {
                    text: '사용일자',
                    width: 164,
                    align: 'center',
                    value: 'payedAt'
                },
                {
                    text: '폐기일자',
                    width: 164,
                    align: 'center',
                    value: 'canceledAt'
                },
                {
                    text: '만기일자',
                    width: 164,
                    align: 'center',
                    value: 'expiredAt'
                },
                {
                    text: '발행처',
                    width: 100,
                    align: "center",
                    value: "cp.name",
                },
                {
                    text: '구매자',
                    width: 100,
                    align: "center",
                    value: "name",
                },
                {
                    text: '사용처',
                    width: 100,
                    align: "center",
                    value: "place",
                },
                {
                    text: '플랫폼',
                    width: 100,
                    align: "center",
                    value: "platform.name",
                }
            ],

            dateItems: [
                { name: "전체", value: null },
                { name: "발행일자", value: "issuedAt" },
                { name: "사용일자", value: "payedAt" },
                { name: "폐기일자", value: "canceledAt" }
            ],

            statusItems: [
                { name: "발행", value: 1 },
                { name: "사용", value: 7 },
                { name: "폐기", value: 8 },
            ],

            lockedItems: [
                { name: "전체", value: null },
                { name: "잠금", value: 1 },
                { name: "활성", value: 0 },
            ]
        };
    },

    mounted(){
        this.init();
    },

    methods: {
        async init(){
            var { me } = await api.console.me.get();
            this.filter.cd = this.payload.scope.includes("console") ? null : me.code;

            this.platforms = [
                { name: ":: 전체 ::", _id: null },
                ...me.categories?.reduce((platforms, category) => [...platforms, ...category.platforms], [])
            ];

            var { cps } = await api.console.me.cps.gets();
            this.cps = [
                { name: ":: 전체 :: ", _id: null },
                ...cps
            ];

            this.search();
        },

        async search(){
            this.searchDashboard();

            this.loadingPins = true;

            var { summary, pins } = await api.console.pins.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.validatedFilter
            });

            this.pins = pins;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.summary = summary;
            this.loadingPins = false;
            this.selected = [];
        },
        async searchDashboard(){
            this.loadingDashboard = true;

            var { dashboard } = await api.console.pins.dashboard({
                params: this.validatedFilter
            });

            this.dashboard = dashboard;
            this.loadingDashboard = false;
        },

        validate(all){
            try{
                if(!all && !this.selected.length) throw new Error("핀을 선택해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        /** @param {Boolean} all */
        editPlatform(all){
            if(this.validate(all)){
                this.$refs["platform-dialog"].filter = this.validatedFilter;
                this.$refs["platform-dialog"].pins = !all ? this.selected : undefined;
                this.$refs["platform-dialog"].all = all;
                
                this.$refs["platform-dialog"].open();
            }
        },

        /** @param {Boolean} all */
        async lock(all){
            if(this.validate(all)){
                await api.console.pins.lock(
                    { pins: this.selected }, 
                    { params: this.validatedFilter }
                );

                alert("핀이 잠금처리 되었습니다");
            }
        },

        /** @param {Boolean} all */
        async unlock(all){
            if(this.validate(all)){
                await api.console.pins.unlock(
                    { pins: this.selected }, 
                    { params: this.validatedFilter }
                );

                alert("핀이 활성처리 되었습니다");
            }
        },

        /** @param {Boolean} all */
        async cancel(all){
            try {
                // 1: 발행, 7: 사용, 8: 폐기
                const canceledPins = this.selected.filter(select => select.status === 8).map(select => select.pno);
                const usedPins = this.selected.filter(select => select.status === 7).map(select => select.pno);

                if (this.alertMessage(canceledPins, "이미 폐기된 핀입니다.")) return;
                if (this.alertMessage(usedPins, "이미 사용된 핀입니다.")) return;

                if(this.validate(all)){
                    await api.console.pins.cancel(
                        { pins: this.selected }, 
                        { params: this.validatedFilter }
                    );

                    alert("핀이 폐기처리 되었습니다");
                }
            } catch(error) {
                console.error(error);
            }
        },

        alertMessage(pins, message) {
            if (pins.length) {
                alert(`${message}\n${pins.join('\n')}`);
                return true;
            }
            return false;
        },

        async excel(){
            
            var { pins } = await api.console.pins.gets({
                params: this.validatedFilter
            });

            var data = [];
            for(var pin of pins){
                data.push({
                    "발권번호": pin.cd + pin.lv + pin.no.toString().padStart(13, 0),
                    "핀번호": pin.pno,
                    "액면가": pin.faceamt.format(),
                    "핀상태": pin.statusMessage,
                    "활성/잠금": pin.lockedMessage,
                    "수신자번호": pin.phone,
                    "발행일자": pin.issuedAt ? dayjs(pin.issuedAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                    "사용일자": pin.payedAt ? dayjs(pin.payedAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                    "폐기일자": pin.canceledAt ? dayjs(pin.canceledAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                    "만기일자": pin.expiredAt ? dayjs(pin.expiredAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                    "사용처": pin.place,
                    "발행처": pin.cp?.name,
                    "플랫폼": pin.platform?.name
                });
            }
            var workbook = XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(workbook, worksheet, "핀 목록");
            XLSX.writeFile(workbook, "핀 검색목록.xlsx");
        }
    },

    computed: {
        ...mapGetters(["hasViewerScope"]),
        totalIssue(){
            return this.dashboard?.reduce((data, { issue }) => ({ price: +issue.price + +data.price, count: +issue.count + +data.count }), { price: 0, count: 0 });
        },
        totalPay(){
            return this.dashboard?.reduce((data, { pay }) => ({ price: +pay.price + +data.price, count: +pay.count + +data.count }), { price: 0, count: 0 });
        },
        totalCancel(){
            return this.dashboard?.reduce((data, { cancel }) => ({ price: +cancel.price + +data.price, count: +cancel.count + +data.count }), { price: 0, count: 0 });
        },
        payload(){
            return this.$store.state.payload;
        },
        validatedFilter(){
            var filter = { ...this.filter };
            
            var dateType = filter.dateType;
            var [sdate, edate] = filter.date;

            delete filter.dateType;
            delete filter.date;

            return {
                ...filter,
                [dateType]: [sdate, edate]
            };
        }
    },

    watch: {
        "$route"(){
            Object.assign(this.filter, this.$props);
            this.search();
        }
    }
}
</script>
